import ReactNativeTextToolkitModule from './ReactNativeTextToolkitModule';

/**
 * Look up a word or phrase using the system dictionary (iOS) or text processing actions (Android).
 * @param text The text to look up
 */
export function lookUp(text: string): void {
  ReactNativeTextToolkitModule.lookUp(text);
}

/**
 * Translate text using the system translation service or Google Translate.
 * @param text The text to translate
 */
export function translate(text: string): void {
  ReactNativeTextToolkitModule.translate(text);
}

export * from './ReactNativeTextToolkit.types';
